import { Icon, IconProps, useTheme } from "@chakra-ui/react";
import React from "react";

type WaitIconProps = IconProps & {
  colorScheme?: string;
};

export const WaitIcon: React.FC<WaitIconProps> = ({
  colorScheme = "gray",
  ...styles
}) => {
  const { colors } = useTheme();
  const palette = colors[colorScheme] ?? colors.gray;

  return (
    <Icon w="240" h="auto" viewBox="0 0 240 180" fill="none" {...styles}>
      <path
        d="M59.3579 130V131.986"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M54.8979 131.076L56.5207 132.747"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M53 135.523H55.2945"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M54.7119 140.049L56.3347 138.379"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M59.3579 140.591V138.605"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M63.6677 140.267L62.3438 138.943"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M65.316 135.958H63.3301"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M63.9919 131.324L62.668 132.648"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M38.9336 7V8.32392"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M35 11H36.3239"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M38.9336 14.9431V13.6191"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M42.2438 10.9717H40.9199"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M188.958 119V120.986"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M183 124.958H184.986"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M188.958 130.253V128.268"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M194.253 124.958H192.268"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M205.865 34C207.447 34 208.73 35.2833 208.73 36.8657C208.73 38.4487 207.447 39.7314 205.865 39.7314C204.283 39.7314 203 38.4487 203 36.8657"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M196 150.849C197.701 150.319 200.309 148.238 200.912 146C201.46 147.979 203.754 150.319 205.824 150.496C203.494 151.321 201.266 153.772 200.912 155.698C200.672 153.735 197.59 151.136 196 150.849Z"
        fill={palette[100]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1299 129.901C21.9807 129.636 23.2839 128.596 23.5857 127.477C23.8594 128.465 25.0064 129.636 26.0416 129.724C24.8766 130.137 23.7627 131.363 23.5857 132.325C23.4655 131.344 21.9245 130.044 21.1299 129.901Z"
        fill={palette[100]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9191 37.8168C36.9191 39.0445 35.9244 40.0389 34.6976 40.0389C33.4702 40.0389 32.4761 39.0445 32.4761 37.8168C32.4761 36.5897 33.4702 35.5947 34.6976 35.5947C35.9244 35.5947 36.9191 36.5897 36.9191 37.8168Z"
        fill={palette[200]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.8901 107.946C61.8901 109.573 60.5717 110.892 58.9453 110.892C57.3184 110.892 56 109.573 56 107.946C56 106.319 57.3184 105 58.9453 105C60.5717 105 61.8901 106.319 61.8901 107.946Z"
        fill={palette[100]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.713 98.8573C33.713 99.8831 32.8818 100.715 31.8562 100.715C30.8312 100.715 30 99.8831 30 98.8573C30 97.8314 30.8312 97 31.8562 97C32.8818 97 33.713 97.8314 33.713 98.8573Z"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.3322 15.5414C77.3322 16.7691 76.3375 17.7635 75.1107 17.7635C73.8839 17.7635 72.8892 16.7691 72.8892 15.5414C72.8892 14.3143 73.8839 13.3193 75.1107 13.3193C76.3375 13.3193 77.3322 14.3143 77.3322 15.5414Z"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.729 79.3223C193.309 79.8625 191.721 79.1492 191.181 77.7298C190.64 76.3099 191.353 74.7202 192.773 74.1806C194.192 73.6404 195.781 74.3531 196.321 75.7731C196.862 77.193 196.148 78.7821 194.729 79.3223Z"
        stroke={palette[200]}
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M121.194 160.027C121.761 159.747 122.295 159.413 122.795 159.031L177.359 116.997C178.881 115.815 179.978 114.222 180.47 112.481C180.962 110.738 180.822 108.947 180.071 107.397L138.543 23.4417C137.839 22.0088 136.645 20.8625 135.129 20.1668C133.614 19.4731 131.855 19.2636 130.101 19.5699L60.6683 31.5924C59.775 31.7564 58.9014 32.045 58.0792 32.4482C56.0475 33.4542 54.4545 35.1361 53.6481 37.1244C52.8437 39.1106 52.8892 41.2412 53.7805 43.0457L110.148 157.005C110.393 157.513 110.707 157.984 111.081 158.411C112.215 159.725 113.834 160.598 115.668 160.891C117.504 161.185 119.451 160.881 121.194 160.027Z"
        fill={palette[50]}
      />
      <path
        d="M119.765 134.157C150.787 134.157 175.944 109.003 175.944 77.9753C175.944 46.9477 150.787 21.7959 119.765 21.7959C88.7352 21.7959 63.5854 46.9477 63.5854 77.9753C63.5854 109.003 88.7352 134.157 119.765 134.157Z"
        fill={palette[300]}
      />
      <path
        d="M140.171 96.4683C140.205 88.4204 135.121 81.2342 127.542 78.5779C127.19 78.4534 127.01 78.0581 127.135 77.7083C127.194 77.5106 127.358 77.3565 127.544 77.2932C135.151 74.6725 140.25 67.5081 140.268 59.4542L140.298 43.301L102.481 43.1982L102.443 59.3692C102.434 67.4073 107.501 74.5856 115.073 77.2596C115.424 77.3822 115.604 77.7794 115.498 78.1372C115.438 78.3328 115.274 78.487 115.086 78.5522C107.481 81.1729 102.38 88.3354 102.354 96.3675L102.317 112.537L140.133 112.639L140.171 96.4683Z"
        fill={palette[50]}
      />
      <path
        d="M135.033 102.891L135.025 107.876L107.426 107.809L107.444 96.0156C107.456 94.6123 107.665 93.211 108.09 91.877L135.033 102.891Z"
        fill={palette[50]}
      />
      <path
        opacity="0.8"
        d="M120.097 96.7861L128.56 103.182L128.556 107.864L135.024 107.876L135.032 102.891L120.097 96.7861Z"
        fill={palette[300]}
      />
      <path
        d="M121.314 73.5987C113.683 73.575 107.531 67.379 107.548 59.7658L108.003 52.2041L134.758 63.1435C133.214 69.2763 127.666 73.6027 121.314 73.5987Z"
        fill={palette[50]}
      />
      <path
        opacity="0.8"
        d="M134.754 63.1495L129.052 60.8193C127.512 66.9442 121.965 71.2706 115.612 71.2666C114.869 71.2647 114.13 71.2034 113.413 71.0907C115.644 72.6679 118.36 73.5968 121.314 73.5988C127.666 73.6027 133.214 69.2764 134.754 63.1495Z"
        fill={palette[300]}
      />
      <path
        d="M98.7832 112.524L143.571 112.643"
        stroke={palette[400]}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.1211 43.1523L143.891 43.263"
        stroke={palette[400]}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M118.848 63.1888C127.064 66.5487 133.038 65.2759 133.981 62.8311L108.632 52.4668C107.928 56.8109 111.181 60.0542 118.848 63.1888Z"
        fill="white"
      />
      <path
        d="M119.389 103.091C127.21 106.289 135.033 102.891 134.718 102.773L108.784 92.1691C108.066 91.9873 111.397 99.8218 119.389 103.091Z"
        fill="white"
      />
      <g style={{ mixBlendMode: "multiply" }} opacity="0.8">
        <path
          d="M161.516 60.0221C170.379 63.6741 180.526 59.4398 184.18 50.5639C187.833 41.6881 183.611 31.5322 174.747 27.8802C165.884 24.2281 155.737 28.4625 152.084 37.3383C148.43 46.2142 152.653 56.3701 161.516 60.0221Z"
          fill={palette[300]}
        />
      </g>
      <path
        d="M163.174 56.7067C172.038 60.3587 182.184 56.1244 185.838 47.2485C189.492 38.3726 185.269 28.2168 176.406 24.5647C167.543 20.9127 157.396 25.147 153.742 34.0229C150.089 42.8988 154.311 53.0547 163.174 56.7067Z"
        fill={palette[200]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.554 41.0951C164.554 42.3228 163.559 43.3172 162.332 43.3172C161.105 43.3172 160.111 42.3228 160.111 41.0951C160.111 39.868 161.105 38.873 162.332 38.873C163.559 38.873 164.554 39.868 164.554 41.0951Z"
        fill={palette[400]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.078 41.0951C172.078 42.3228 171.083 43.3172 169.856 43.3172C168.629 43.3172 167.635 42.3228 167.635 41.0951C167.635 39.868 168.629 38.873 169.856 38.873C171.083 38.873 172.078 39.868 172.078 41.0951Z"
        fill={palette[400]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.602 41.0951C179.602 42.3228 178.607 43.3172 177.38 43.3172C176.153 43.3172 175.159 42.3228 175.159 41.0951C175.159 39.868 176.153 38.873 177.38 38.873C178.607 38.873 179.602 39.868 179.602 41.0951Z"
        fill={palette[400]}
      />
    </Icon>
  );
};
